module.exports = __webpack_public_path__ + "639eca0c7cf482bc133c5cd614eb1954.pdf";